import { KeyValue } from "@/models";
import { useQueryGetRoomsByOwnerId } from "@/services/API/hooks/room-hooks";
import { useMemo } from "react";
import { RoomAutocompleteProps } from "./room-autocomplete.types";

export const useRoomAutocomplete = ({
  value,
  targetUserId,
  enabled = true,
  roomNameFallback = "Room",
}: Pick<RoomAutocompleteProps, "value" | "targetUserId" | "enabled" | "roomNameFallback">) => {
  const { rooms, isLoading } = useQueryGetRoomsByOwnerId(enabled, targetUserId);

  const roomsOptions = useMemo(() => {
    return rooms.map<KeyValue>((room) => ({
      key: room._id,
      value: room.name ?? roomNameFallback,
    }));
  }, [rooms, roomNameFallback]);

  const selectedRoom = useMemo(
    () => roomsOptions.find((room) => room.key === value) || null,
    [roomsOptions, value]
  );

  return {
    roomsOptions,
    selectedRoom,
    isLoading,
  };
};
